module.exports = __webpack_public_path__ + "img/electrician.6e3acb07.jpg";